import React from "react";
import Reveal from "@/components/Reveal";

export default function SectionHeading({ eyebrow, title, subtitle, align = "left", darkBg = false }) {
  const textColor = darkBg ? "text-white" : "text-[#0B3D91]";
  const subColor = darkBg ? "text-white/80" : "text-[#555]";
  const eyeColor = darkBg ? "text-[#F9B233]" : "text-[#F9B233]";
  const alignClass = align === "center" ? "text-center mx-auto" : "";

  return (
    <Reveal>
      <div className={`max-w-3xl ${alignClass}`}>
        {eyebrow && (
          <span className={`inline-block text-xs font-bold tracking-[0.2em] uppercase mb-3 ${eyeColor}`}>
            {eyebrow}
          </span>
        )}
        <h2 className={`text-3xl md:text-4xl lg:text-5xl font-bold tracking-tight leading-[1.15] ${textColor}`}>
          {title}
        </h2>
        {subtitle && (
          <p className={`mt-4 text-base md:text-lg leading-relaxed ${subColor}`}>{subtitle}</p>
        )}
      </div>
    </Reveal>
  );
}
